const BSCMainnetChainId = 56;
const BSCTestnetChainId = 97;

export {
  BSCMainnetChainId,
  BSCTestnetChainId,
};
